<template>
  <div class="container is-fluid">
    <div class="columns">
      <div class="column">
        <p class="title is-1" align="center">Ready for a Challenge?</p>

        <div class="columns">
          <!-- Load Challenge Stats -->
          <div class="column is-one-third">
            <p class="title is-4 is-spaced" align="center">CHALLENGE DATA</p>
            <p class="subtitle is-3" align="center">Current Challenges</p>
            <table class="table is-striped is-narrow-tablet is-narrow-mobile is-hoverable">
              <thead>
                <tr>
                  <th>Challenging</th>
                  <th>Challenge Start</th>
                  <th>Duration</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(current, index) in challenges">
                  <td v-if="current.opponentId == user.id">{{ current.challengerFirstName }}</td>
                  <td v-else>{{ current.opponentFirstName }}</td>
                  <td>{{ current.startDate }}</td>
                  <td v-if="current.accepted">{{ current.duration }}</td>
                  <td v-else></td>
                  <td>
                    <button :key="current.key"
                        v-if="!current.accepted && current.opponentId == user.id"
                        @click="acceptChallenge(current.key, true)">Accept</button>
                    <button :key="current.key"
                        v-if="!current.accepted && current.opponentId == user.id"
                        @click="acceptChallenge(current.key, false)">Decline</button>
                    <button v-else-if="!current.accepted">Waiting</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Load google map view -->
          <div v-show='showMap' class="column is-one-third">
            <div class="field has-addons">
              <div class="control is-expanded">
                <input class="input"
                  type="email"
                  id="SearchEmail"
                  placeholder="Email"
                  v-model="email"
                  v-on:keyup.enter="searchForUser">
              </div>
              <div class="control">
                <a class="button is-dark" @click="searchForUser">Search</a>
              </div>
            </div>
            <gmap-map :center="mapCenter" :zoom="8" style="width: 100%; height: 400px">
              <gmap-marker
                :key="index"
                v-for="(c, index) in availableChallengers"
                :position="c.position"
                :clickable="true"
                :draggable="false"
                :icon="{ url: 'https://image.ibb.co/cReVdx/rsz_logo.png'}"
                @click="showModal(c.name, c.rank, c.id)">
              </gmap-marker>
            </gmap-map>
            <button class="button is-dark is-fullwidth toggle" @click="show" >List View</button>
          </div>

          <!-- Load list view view -->
          <div v-show="!showMap" class="column is-one-third">
            <div class="field has-addons">
              <div class="control is-expanded">
                <input class="input" type="text" placeholder="Email">
              </div>
              <div class="control">
                <a class="button is-dark">Search</a>
              </div>
            </div>
            <table class="table is-striped is-narrow-tablet is-narrow-mobile is-hoverable">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Rank</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(c, index) in availableChallengers">
                  <td>{{ c.name }}</td>
                  <td>{{ c.rank }}</td>
                  <td>
                    <button class="button is-small" @click="showModal(c.name, c.rank, c.id)">Challenge!</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <button class="button is-dark is-fullwidth toggle" @click="show">Map View</button>
          </div>

          <!-- Load challenge history table -->
          <div class="column is-one-third">
            <p class="title is-4" align="center">RECENT CHALLENGES</p>
            <table class="table is-striped is-narrow-tablet is-narrow-mobile is-hoverable">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Outcome</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="challenge in pastChallenges">
                  <td>{{ challenge.user }}</td>
                  <td>{{ challenge.outcome }}</td>
                  <td>
                    <button class="button is-small" @click="showModal(challenge.user, null, challenge.key)">Challenge Again!</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Declare challenge modal details -->
    <challenge-modal
      v-show="showChallengeModal"
      @close="showChallengeModal = false">
    </challenge-modal>
  </div>
</template>

<script>
import * as firebase from 'firebase'
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue'
import challengeModal from './challengeModal.vue'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import { mapGetters } from 'vuex'

  //Include the use of google maps in Vue
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyBIgWkXLfO8bgbBfQF_N-r7Ut0SK0DRzRE',
      v: '3'
    }
  })

  export default {
    components: {
      'challenge-modal': challengeModal,
    },
    data(){
      return {
        searchedUser: {
          id: '',
          email: '',
          firstName: '',
          lastName: '',
          rank: ''
        },

        showChallengeModal: false,
        showMap: true,
        foundEmail: false,

        email: ''
      }
    },
    computed: {
      ...mapGetters([
        'challenges',
        'pastChallenges',
        'availableChallengers',
        'user',
        'mapCenter'
      ])
    },
    mounted() {
      this.daysLeft()
      /*
          this listener listens for when the challengeModal closes
          if you don't set these to false you can't search again because it stores
          the information that was there on the last search
       */
      this.$root.$on('close', function() {
        this.foundEmail = false
        this.showChallengeModal = false
      })

      this.$root.$on('closeChallengeModal', function () {
        this.showChallengeModal = false
      })
    },
    methods: {
      //Accept/decline challenge by changing accept value in the store and updating firebase accordingly
      acceptChallenge (key, acceptVal) {
        var d = new Date()
        let challengeStart =  (d.getMonth() + 1) + '/' + (d.getDate()+1) + '/' + d.getFullYear()

        let updatedChallenge = {
          key: key,
          opponentHasAccepted: acceptVal,
          startDate: challengeStart
        }
        this.$store.dispatch('acceptChallenge', updatedChallenge)
      },

      // get daysLeft in challenge
      daysLeft() {
        let opposeName = ''
        let opposeRank = ''
        let opposeId = ''
        let t = new Date()
        let today = Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())
        const _MS_PER_DAY = 1000 * 60 * 60 * 24
        const challenges = this.challenges
        console.log(challenges);
        const currentId = this.user.id
        console.log(currentId);
        const currentName = this.user.firstName
        const currentRank = this.user.rank

        for (let val in challenges) {
          let start = new Date(challenges[val].startDate)
          let duration = challenges[val].duration
          let key = challenges[val].key
          let daysSinceStart = (Math.ceil((today - start) / _MS_PER_DAY))

          if (currentId == challenges[val].opponentId) {
            opposeId = challenges[val].challengerId
            opposeName = challenges[val].challengerFirstName
            if(challenges[val].challengerRank == null || challenges[val].challengerRank == undefined) {
              opposeRank = 'No Rank'
            } else {
              opposeRank = challenges[val].challengerRank
            }
          } else if (currentId == challenges[val].challengerId) {
            opposeId = challenges[val].opponentId
            opposeName = challenges[val].opponentFirstName
            if (challenges[val].opponentRank == null || challenges[val].opponentRank == undefined) {
              opposeRank = 'No Rank'
            } else {
              opposeRank = challenges[val].opponentRank
            }

          }

          if (daysSinceStart >= duration) {
            let end = this.formatDate(start, (duration-1))
            console.log('end: ' + end);

            let formatStart = this.formatDate(start, 0)
            console.log('start: ' + formatStart);

            firebase.database().ref('users').child(opposeId).once('value')
              .then((data) => {
                const obj = data.val()

                const opposeData = {
                  fitbitId: obj.fitbitID,
                  authToken: obj.fitbitAccessToken
                }
                console.log('get: ' + JSON.stringify(opposeData));

                axios.all([this.getLoggedInSteps(end, formatStart), this.getOpposeSteps(end, formatStart, opposeData.fitbitId, opposeData.authToken)])
                  .then(axios.spread(function (obj1, obj2) {
                    let sum1 = 0
                    console.log('comp1: ' + obj1);
                    obj1 = JSON.stringify(obj1.data)
                    obj1 = JSON.parse(obj1.split('steps\":')[1].split(']}')[0]+']')
                    for (var j in obj1) {
                      sum1 += parseInt(obj1[j].value)
                    }
                    console.log('Sum1: ' + sum1);

                    let sum2 = 0
                    console.log('comp2: ' + obj2);
                    obj2 = JSON.stringify(obj2.data)
                    obj2 = JSON.parse(obj2.split('steps\":')[1].split(']}')[0]+']')
                    for (var j in obj2) {
                      sum2 += parseInt(obj2[j].value)
                    }
                    console.log('sum2: ' + sum2);

                    let win = ''
                    let win2 = ''
                    if (sum1 > sum2) {
                      win = 'WON'
                      win2 = 'LOST'
                    } else if (sum2 > sum1) {
                      win = 'LOST'
                      win2 = 'WON'
                    } else {
                      win = 'TIED'
                      win2 = 'TIED'
                    }

                    console.log('win: ' + win);
                    console.log('win2: ' + win2);

                    //add to current users challenge history
                    firebase.database().ref('users').child(currentId).child('challengeHistory').child(key).update({
                      opponentId: opposeId,
                      winnerId: win,
                      opponentFirstName: opposeName,
                      opponentRank: opposeRank
                    })
                    .catch((error) => { console.log(error) })

                    //add to opposing users challenge history
                    firebase.database().ref('users').child(opposeId).child('challengeHistory').child(key).update({
                      opponentId: currentId,
                      winnerId: win2,
                      opponentFirstName: currentName,
                      opponentRank: currentRank
                    })
                    .catch((error) => { console.log(error) })
                  }));
                  //Delete challenge from challenges array
                  this.$store.dispatch('deleteChallenge', key)
              })
              .catch((error) => { console.log(error) })
          }
        }
      },

      getLoggedInSteps(end, start) {
        if (this.$cookies.isKey('oauth_access_token')) {
          var AuthString = 'Bearer '+(this.$cookies.get('oauth_access_token'))
          axios.defaults.headers.common['Authorization'] = AuthString

          //Call for steps of current user logged in
          return axios.get('https://api.fitbit.com/1/user/-/activities/tracker/steps/date/'+start+'/'+end+'.json')
        }
      },
      getOpposeSteps(end, start, opposeFitbitId, opposeAuthToken) {
        if (opposeAuthToken !== null) {
          var AuthString = 'Bearer '+opposeAuthToken
          axios.defaults.headers.common['Authorization'] = AuthString

          //Call for steps of other user invovled in challenge
          return axios.get('https://api.fitbit.com/1/user/'+opposeFitbitId+'/activities/tracker/steps/date/'+start+'/'+end+'.json')
        }
      },

      formatDate(d, sub) {
        var end = ''
        var endD = new Date(d)
        endD.setDate(endD.getDate() + sub)

        //Convert date format to fitbit friendly YYYY-MM-DD
        if ((endD.getMonth()+1)<10) {
          if (endD.getDate()<10) {
            end = endD.getFullYear()+'-0'+(endD.getMonth()+1)+'-0'+endD.getDate()
          } else {
            end = endD.getFullYear()+'-0'+(endD.getMonth()+1)+'-'+endD.getDate()
          }
        } else {
          if (endD.getDate()<10) {
            end = endD.getFullYear()+'-'+(endD.getMonth()+1)+'-0'+endD.getDate()
          } else {
            end = endD.getFullYear()+'-'+(endD.getMonth()+1)+'-'+endD.getDate()
          }
        }
        return end
      },

      //Call challenge modal and emit the chosen user to be challenged
      showModal(n, r, i) {
        this.searchedUser.firstName = n
        this.searchedUser.rank = r
        this.searchedUser.id = i
        this.$root.$emit('selectOpponent', this.searchedUser)
        this.showChallengeModal=true

        this.searchedUser.firstName = null
        this.searchedUser.rank = null
        this.searchedUser.id = null
      },

      // Creates a toggle button for the map or list views.
      show() {
        if (this.showMap) {
          document.getElementsByClassName('toggle').innerHTML = 'Map View';
        } else {
          document.getElementsByClassName('toggle').innerHTML = 'List View';
        }
        this.showMap = !this.showMap;
      },

      // search for user by email
      //----------------------------------------------------------
      // future implementation will search by username
      //----------------------------------------------------------
      searchForUser () {
        firebase.database().ref('users').once('value')
          .then((data) => {
            const obj = data.val()  // store all objects
            for (let key in obj) {  // for each key in the group
              let tempId = key
              let tempEmail = obj[key].email
              let firstName = obj[key].firstName
              let lastName = obj[key].lastName
              let rank = obj[key].rank

              if (this.email === tempEmail) {
                this.foundEmail = true
                this.searchedUser.id = tempId
                this.searchedUser.email = tempEmail
                this.searchedUser.firstName = firstName
                this.searchedUser.rank = rank
              }
            }
            if (this.foundEmail) {
              this.$root.$emit('selectOpponent', this.searchedUser)  // emit the event that we found a match
              this.showChallengeModal = true
              this.foundEmail = false
            } else {
              this.showChallengeModal = false
              this.$toasted.show("User not found. Check entry and try again.", {
                theme: "outline",
                position: "top-center",
                duration : 3000,
                fitToScreen: true
              })
            }

            this.searchedUser.id = ''
            this.searchedUser.email = ''
            this.searchedUser.firstName = ''
            this.searchedUser.rank = ''
          })
          .catch((error) => { console.log(error) })
      },

      // toRadians(degrees){
      //   return degrees * Math.PI / 180;
      // },
      // calcDistance(pos1,pos2){
      //   var R = 6371e3; // metres
      //   var lat1 = this.toRadians(this.markers[0].position.lat);
      //   var lat2 = this.toRadians(this.tempPos.lat);
      //   var deltaLat = this.toRadians(this.tempPos.lat-this.markers[0].position.lat);
      //   var deltaLon = this.toRadians(this.tempPos.lng-this.markers[0].position.lng);
      //
      //   var a = Math.sin(deltaLat/2) * Math.sin(deltaLat/2) +
      //           Math.cos(lat1) * Math.cos(lat2) *
      //           Math.sin(deltaLon/2) * Math.sin(deltaLon/2);
      //   var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      //
      //   var d = R * c;
      //   var dm = d * 0.000621371;
      //   console.log("Distance was: ", dm)
      //   return dm;
      // }
    }
  }
</script>

<style scoped>
  thead th {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Challenge/Challenge.vue